import { Switch } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Popover } from '../../ui';

import s from './index.module.scss';

interface ISwitchButtonProps {
	label: string;
	onClick: (value: boolean) => void;
	loading: boolean;
	checked: boolean;
	disabled?: boolean;
	tooltip?: string;
}
export const SwitchButton: FC<ISwitchButtonProps> = ({
	label,
	onClick,
	loading,
	disabled,
	checked,
	tooltip,
}) => {
	const props = { label, onClick, loading, checked, disabled };

	const { t } = useTranslation();
	return (
		<div className={s.root}>
			<div className={s.label}>{label}</div>
			{tooltip ? (
				<Popover content={t(tooltip)} placement="topRight">
					<Switch {...props} />
				</Popover>
			) : (
				<Switch {...props} />
			)}
		</div>
	);
};
